import React from 'react';

interface CloudProps {
  position: [number, number, number];
  scale?: number;
}

export const Cloud: React.FC<CloudProps> = ({ position, scale = 1 }) => {
  // Create a soft blueish-white color for clouds
  const cloudColor = '#F0F8FF';

  return (
    <group position={position} scale={scale}>
      {/* Main cloud shape made of multiple connected low poly shapes */}
      <mesh castShadow>
        <dodecahedronGeometry args={[0.9, 0]} />
        <meshStandardMaterial
          color={cloudColor}
          flatShading
          emissive={cloudColor}
          emissiveIntensity={0.1}
        />
      </mesh>

      <mesh position={[0.8, -0.1, 0]} castShadow>
        <octahedronGeometry args={[0.7, 0]} />
        <meshStandardMaterial
          color={cloudColor}
          flatShading
          emissive={cloudColor}
          emissiveIntensity={0.1}
        />
      </mesh>

      <mesh position={[-0.8, 0.1, 0]} castShadow>
        <icosahedronGeometry args={[0.65, 0]} />
        <meshStandardMaterial
          color={cloudColor}
          flatShading
          emissive={cloudColor}
          emissiveIntensity={0.1}
        />
      </mesh>

      <mesh position={[0, 0.5, 0]} castShadow>
        <octahedronGeometry args={[0.5, 0]} />
        <meshStandardMaterial
          color={cloudColor}
          flatShading
          emissive={cloudColor}
          emissiveIntensity={0.1}
        />
      </mesh>

      <mesh position={[0.5, 0.3, 0.4]} castShadow>
        <dodecahedronGeometry args={[0.4, 0]} />
        <meshStandardMaterial
          color={cloudColor}
          flatShading
          emissive={cloudColor}
          emissiveIntensity={0.1}
        />
      </mesh>

      <mesh position={[-0.5, -0.2, -0.4]} castShadow>
        <dodecahedronGeometry args={[0.5, 0]} />
        <meshStandardMaterial
          color={cloudColor}
          flatShading
          emissive={cloudColor}
          emissiveIntensity={0.1}
        />
      </mesh>

      <mesh position={[0, -0.1, 0.6]} castShadow>
        <octahedronGeometry args={[0.45, 0]} />
        <meshStandardMaterial
          color={cloudColor}
          flatShading
          emissive={cloudColor}
          emissiveIntensity={0.1}
        />
      </mesh>

      <mesh position={[0.4, -0.4, -0.4]} castShadow>
        <icosahedronGeometry args={[0.35, 0]} />
        <meshStandardMaterial
          color={cloudColor}
          flatShading
          emissive={cloudColor}
          emissiveIntensity={0.1}
        />
      </mesh>

      <mesh position={[-0.4, 0.4, 0.1]} castShadow>
        <dodecahedronGeometry args={[0.4, 0]} />
        <meshStandardMaterial
          color={cloudColor}
          flatShading
          emissive={cloudColor}
          emissiveIntensity={0.1}
        />
      </mesh>
    </group>
  );
};
